import styled from "styled-components";

import { colorsPalettes } from "@similarweb/styles";
import { IconButton } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

export const TotalVisitsComponentHistoryHookContainer = styled(Flex)`
    position: relative;
    background: ${colorsPalettes.blue[100]};
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    padding: 18px 25px 21px;
`;

export const TotalVisitsComponentHistoryHookButton = styled(IconButton)`
    position: absolute;
    top: 4px;
    right: 4px;
`;

export const TotalVisitsComponentHistoryHookImage = styled.img`
    width: 80px;
    height: 80px;
`;
